module.exports = __webpack_public_path__ + "assets/img/NothingFoundHere@2x.0dd701ce.png";